<template>
  <v-container>
    <v-row class="text-center">
      <!-- <v-col cols="12">
        <v-img
          :src="require('../assets/logo.svg')"
          class="my-3"
          contain
          height="200"
        />
      </v-col> -->
      <v-col cols="12"></v-col>
      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Mouse Sensitivity Converter / Calculator
        </h1>

        <!-- <p class="subheading font-weight-regular">
          Mouse Sensitivity Converter / Calculator
        </p> -->
        <h7 class="mb-3">You can try </h7>
        <a href="http://www.fpshelper.com/en/advanced"
          >Advanced mouse sensitivity converter
        </a>
        <h7 class="mb-3">for more options.</h7>
      </v-col>

      <v-col cols="12">
        <v-row justify="center">
          <v-col class="d-flex" cols="12" sm="4">
            <v-select
              :items="games"
              label="Convert From"
              item-value="0"
              v-model="fromGame"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4">
            <v-text-field
              label="Sensitivity"
              outlined
              v-model="oriSens"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col class="d-flex" cols="12" sm="4">
            <v-select
              :items="games"
              label="Convert To"
              outlined
              v-model="toGame"
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4">
            <v-text-field
              disabled
              label="Outcome"
              v-model="convertedSens"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="12" sm="8">
            <v-card outlined>
              <v-card-title class="display-1">Usage</v-card-title>
              <v-card-text class="title text-left">
                &nbsp;&nbsp;&nbsp;&nbsp;Mouse sensitivity converter is used to
                convert the mouse sensitivity from one game to the mouse
                sensitivity of another game (mouse sensitivity can be found in
                the game settings). When using the converter, the user needs to
                select the source game type and the target game type, and input
                the mouse sensitivity value in the source game, then the
                converted sensitivity will be showed in the lower right corner
                in real time.
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="8">
            <InnerLink></InnerLink>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InnerLink from "./InnerLink.vue";
export default {
  name: "SensConv",
  components: {
    InnerLink,
  },
  metaInfo: {
    title: "Mouse Sensitivity Converter: A Free To Use FPS Game Utility", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "Mouse Sensitivity Converter, \
          Mouse Sensitivity calculator, \
          game Sensitivity Converter, \
          game Sensitivity calculator, \
          sens converter, \
          sense converter, \
          sensitivity calculator, \
          sens calculator, \
          APEX,\
          counter strike,\
          overwatch\
          ",
      },
      {
        // set meta
        name: "description",
        content:
          "This website is used to convert(calculate) the mouse sensitivity between different games. This tool is free to use, and will be updated continuously.",
      },
    ],
    link: [
      {
        // set link
        rel: "asstes",
        href: "http://fpshelper.com/en/conv/",
      },
    ],
  },
  methods: {},
  data: () => ({
    fromGame: "",
    toGame: "",
    oriSens: "",
    games: [
      "CS:GO",
      "CS:S",
      "CS 1.6",
      // "CrossFire",
      // "CFHD",
      "Apex Legends",
      "Battlefield 2042",
      "Battlefield V",
      "Battlefield 1",
      "Battlefield 4",
      "Battlefield 3",
      "Call of Duty: Vanguard",
      "Call of Duty: Black Ops Cold War",
      "Call of Duty: Modern Warfare (2019,Warzone)",
      "Call of Duty: Black Ops 4",
      // "Rainbow Six Siege",
      "Overwatch",
      // "Escape From Tarkov",
      // "Valorant",
      // "Halo Infinite",
      // "PUBG",
    ],
    game2std: {
      "CS:GO": (x) => {
        return x;
      },
      "CS:S": (x) => {
        return x;
      },
      "CS 1.6": (x) => {
        return x;
      },
      CrossFire: (x) => {
        return (x + 5.0) / 10.0;
        //10.0 * x - 5.0;
      },
      CFHD: (x) => {
        //x + 2.0;
        return x - 2.0;
      },
      "Apex Legends": (x) => {
        return x;
      },
      "Battlefield 2042": (x) => {
        return (x - 0.010777) / 0.015777 + 1.0;
        //(x - 1.0) * 0.015777 + 0.010777;
      },
      "Battlefield V": (x) => {
        return (x - 0.0046) / 0.0096 + 1.0;
        //(x - 1.0) * 0.0096 + 0.0046;
      },
      "Battlefield 1": (x) => {
        return (x - 0.0046) / 0.0096 + 1.0;
        //(x - 1.0) * 0.0096 + 0.0046;
      },
      "Battlefield 4": (x) => {
        return (x - 0.0046) / 0.0096 + 1.0;
        //(x - 1.0) * 0.0096 + 0.0046;
      },
      "Battlefield 3": (x) => {
        return (x - 0.036736) / 0.041736 + 1.0;
        //(x - 1.0) * 0.041736 + 0.036736;
      },
      "Call of Duty: Vanguard": (x) => {
        return (x * 3.0) / 10.0;
        //(x * 10.0) / 3.0;
      },
      "Call of Duty: Black Ops Cold War": (x) => {
        return (x * 3.0) / 10.0;
        //(x * 10.0) / 3.0;
      },
      "Call of Duty: Modern Warfare (2019,Warzone)": (x) => {
        return (x * 3.0) / 10.0;
        //(x * 10.0) / 3.0;
      },
      "Call of Duty: Black Ops 4": (x) => {
        return (x * 3.0) / 10.0;
        //(x * 10.0) / 3.0;
      },
      "Rainbow Six Siege": (x) => {
        return (x * 3.0) / 20.0;
        //(x * 20.0) / 3.0;
      },
      Overwatch: (x) => {
        return (x * 3.0) / 10.0;
        //(x * 10.0) / 3.0;
      },
      "Escape From Tarkov": (x) => {
        //x * 0.176;
        return x / 0.176;
      },
      Valorant: (x) => {
        // x * 0.31425;
        return x / 0.31425;
      },
      "Halo Infinite": (x) => {
        return (x * 3.0) / 10.0;
        //(x * 10.0) / 3.0;
      },
      PUBG: (x) => {
        return (x * 3.0) / 10.0;
        //(x * 10.0) / 3.0;
      },
    },
    std2game: {
      "CS:GO": (x) => {
        return x;
      },
      "CS:S": (x) => {
        return x;
      },
      "CS 1.6": (x) => {
        return x;
      },
      CrossFire: (x) => {
        return 10.0 * x - 5.0;
      },
      CFHD: (x) => {
        return x + 2.0;
      },
      "Apex Legends": (x) => {
        return x;
      },
      "Battlefield 2042": (x) => {
        return (x - 1.0) * 0.015777 + 0.010777;
      },
      "Battlefield V": (x) => {
        return (x - 1.0) * 0.0096 + 0.0046;
      },
      "Battlefield 1": (x) => {
        return (x - 1.0) * 0.0096 + 0.0046;
      },
      "Battlefield 4": (x) => {
        return (x - 1.0) * 0.0096 + 0.0046;
      },
      "Battlefield 3": (x) => {
        return (x - 1.0) * 0.041736 + 0.036736;
      },
      "Call of Duty: Vanguard": (x) => {
        return (x * 10.0) / 3.0;
      },
      "Call of Duty: Black Ops Cold War": (x) => {
        return (x * 10.0) / 3.0;
      },
      "Call of Duty: Modern Warfare (2019,Warzone)": (x) => {
        return (x * 10.0) / 3.0;
      },
      "Call of Duty: Black Ops 4": (x) => {
        return (x * 10.0) / 3.0;
      },
      "Rainbow Six Siege": (x) => {
        return (x * 20.0) / 3.0;
      },
      Overwatch: (x) => {
        return (x * 10.0) / 3.0;
      },
      "Escape From Tarkov": (x) => {
        return x * 0.176;
      },
      Valorant: (x) => {
        return x * 0.31425;
      },
      "Halo Infinite": (x) => {
        return (x * 10.0) / 3.0;
      },
      PUBG: (x) => {
        return (x * 10.0) / 3.0;
      },
    },
  }),
  computed: {
    convertedSens: function () {
      if (!this.fromGame || !this.toGame || isNaN(parseFloat(this.oriSens)))
        return "Invalid Input";
      if (this.fromGame == this.toGame) return this.oriSens;
      let std = this.game2std[this.fromGame](parseFloat(this.oriSens));
      let std2 = this.std2game[this.toGame](std);
      console.log(
        this.fromGame,
        this.toGame,
        this.game2std[this.fromGame],
        this.std2game[this.toGame],
        std
      );
      return std2.toString();
    },
  },
};
</script>
